<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to Compensation Summary page" @click="backToSummaryPage">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <details-menu :id="3" :userId="selectedUserId"></details-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="2" class="progress-bar-top"></v-progress-linear>
            </v-card>

            <!-- EMPLOYEE DETAILS -->
            <v-card v-if="userDetails" class="elevation-1 mt-5">
                <v-toolbar flat height="40">
                    <span class="font-weight-bold primary--text">EMPLOYEE DETAILS</span>
                    <v-spacer></v-spacer>
                    <v-btn @click="showAllEmployees" icon title="Select other employee">
                        <v-icon>list</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-layout row wrap> 
                        <v-flex xs12 sm6>
                            <v-layout row wrap :class="isMobile?'form-data-mobile':'form-data'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Employee Name :
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <v-chip @click="viewUserProfile(userDetails, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(userDetails.userId)"></v-img>
                                        </v-avatar>
                                        <b>{{userDetails.firstName}} {{userDetails.lastName}}</b>
                                    </v-chip>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'form-data-mobile':'form-data'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Employee Id : 
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                <b>{{userDetails.employeeId}}</b>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'form-data-mobile':'form-data'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Position : 
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <b>{{userDetails.position}}</b>
                                </v-flex>  
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-layout row wrap :style="isMobile?'padding:0px 0px 0px 10px':'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Hire Date : 
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                <b>
                                    <span v-if="userDetails.hireDate!=null">{{userDetails.hireDate|moment('MMM DD, YYYY')}}</span>
                                    <span v-else class="orange--text">Not updated</span>
                                </b>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :style="isMobile?'padding:0px 0px 0px 10px':'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Employment Status :
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <b v-if="isDeactivted" :class="commonfn.getStatusColor(userDetails.employmentStatus)">{{commonfn.getStatusDescription(userDetails.employmentStatus)}} on {{ userDetails.deactivatedOn | moment('MMM DD, YYYY') }}</b>
                                    <b v-else-if="isResignedOrTerminated" :class="commonfn.getStatusColor(userDetails.employmentStatus)">{{commonfn.getStatusDescription(userDetails.employmentStatus)}} on {{ userDetails.endDate | moment('MMM DD, YYYY') }}</b>
                                    <b v-else :class="commonfn.getStatusColor(userDetails.employmentStatus)">{{commonfn.getStatusDescription(userDetails.employmentStatus)}}</b>
                                </v-flex>  
                            </v-layout>
                            <v-layout row wrap :style="isMobile?'padding:0px 0px 0px 10px':'padding:0px 20px 0px 50px;'"> 
                                <v-flex xs5 class="text-xs-left">
                                    Salary Type :
                                </v-flex>
                                <v-flex xs7 class="text-xs-left">
                                    <b>{{commonfn.getSalaryTypeName(userDetails.salaryType)}}</b>
                                </v-flex>  
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <!-- DE MINIMIS BENEFITS HISTORY -->
            <v-card v-if="userDetails" class="elevation-1 mt-5">
                <v-toolbar flat height="40">
                    <span class="font-weight-bold primary--text">DE MINIMIS BENEFITS HISTORY</span>
                    <v-spacer></v-spacer>
                     <v-btn v-if="isMobile" icon @click="dialogThresholdSummary=true">
                        <v-icon small>data_usage</v-icon>
                    </v-btn>
                    <v-btn v-if="!isMobile" class="primary" small @click="dialogThresholdSummary=true">
                        <v-icon small>data_usage</v-icon>&nbsp;View Threshold&nbsp;
                    </v-btn>
                    <v-btn v-if="hasAddRights" fab class="primary" small @click="add">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-data-table
                    :headers="headers_deminimis"
                    :items="deminimisHistory"
                    :expand="expand" 
                    item-key="deminimisAllocationId"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    :hide-headers="isMobile"
                >
                    <template v-slot:items="props">

                        <!-- mobile view -->
                        <tr v-if="isMobile">
                            <td :colspan="headers_deminimis.length" class="pa-1">
                                <v-card class="rounded-5">
                                    <v-toolbar flat height="40" class="transparent">
                                        <v-chip small>{{props.item.fiscalYear}}</v-chip>
                                        <v-spacer></v-spacer>
                                        <v-menu left offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon small v-bind="attrs" v-on="on" @click.stop :loading="loading_action[props.index]">
                                                    <v-icon small>more_vert</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-tile v-show="hasEditRights && (isCreated(props.item)||isRejected(props.item))" @click="edit(props.item, props.index)" title="Click to edit this record">
                                                    <v-list-tile-title>Edit</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile v-show="hasEditRights && isCreated(props.item)" @click="forReview(props.item, props.index)" title="Click to set this record to For Review">
                                                    <v-list-tile-title>For Review</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile v-show="hasApproverRights && (isForReview(props.item)||isRejected(props.item))" @click="approve(props.item, props.index)" title="Click to Approve this record">
                                                    <v-list-tile-title>Approve</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile v-show="hasApproverRights && (isForReview(props.item)||isApproved(props.item))" @click="reject(props.item, props.index)" title="Click to Reject this record">
                                                    <v-list-tile-title>Reject</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile v-show="hasDeleteRights && (isCreated(props.item)||isRejected(props.item))" @click="showDeleteConfirmation(props.item, props.index)" title="Click to Delete this record">
                                                    <v-list-tile-title>Delete</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </v-toolbar>
                                    <v-divider></v-divider>
                                    <v-layout row wrap align-center class="section-layout">
                                        <v-flex xs12 class="text-xs-left mt-5">
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Type</div>
                                                    <div>{{ props.item.deminimisName }}</div>
                                                </v-flex>
                                                <v-flex xs8>
                                                    <div class="caption grey--text text--darken-1">Payout On</div>
                                                    <pay-on-month :payOnMonth="props.item.payOnMonth2" :shortenMonths="true"></pay-on-month>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Payout Schedule</div>
                                                    <div>{{ getPayoutType(props.item.payoutMode) }}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Monthly Amount</div>
                                                    <div>{{ numFormat.formatNumber(props.item.monthlyAmount) }}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Cutoff Amount</div>
                                                    <div v-if="props.item.payoutMode==3">{{numFormat.formatNumber((props.item.monthlyAmount/2))}}</div>
                                                    <div v-else>{{numFormat.formatNumber(props.item.monthlyAmount)}}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Annual Amount</div>
                                                    <div>{{ numFormat.formatNumber(props.item.annualPayment) }}</div>
                                                </v-flex>
                                                <v-flex xs4>
                                                    <div class="caption grey--text text--darken-1">Status</div>
                                                    <div :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</div> 
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </td>
                        </tr>

                        <!-- desktop view -->
                        <tr v-else @click="props.expanded=!props.expanded" class="clickable" title="Click to view other details">
                            <td>{{ props.item.fiscalYear }}</td>
                            <td>{{ props.item.deminimisName }}</td>
                            <td>
                                <pay-on-month :payOnMonth="props.item.payOnMonth2" :shortenMonths="true"></pay-on-month>
                            </td>
                            <td>
                                <v-chip small class="user-chip-container">
                                    {{ getPayoutType(props.item.payoutMode) }}
                                </v-chip>
                            </td>
                            <td class="text-xs-right">
                                {{ numFormat.formatNumber(props.item.monthlyAmount) }}
                            </td>
                            <td class="text-xs-right">
                                <span v-if="props.item.payoutMode==3">{{numFormat.formatNumber((props.item.monthlyAmount/2))}}</span>
                                <span v-else>{{numFormat.formatNumber(props.item.monthlyAmount)}}</span>
                            </td>
                            <td class="text-xs-right">
                                {{ numFormat.formatNumber(props.item.annualPayment) }}
                            </td>
                            <td>
                                <span :class="commonfn.getStatusColor(props.item.status)">{{ commonfn.getStatusDescription(props.item.status) }}</span> 
                            </td>
                            <td title="Click to view action menu" @click.stop>
                                <v-menu left offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon small v-bind="attrs" v-on="on" @click.stop :loading="loading_action[props.index]">
                                            <v-icon small>more_vert</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list dense>
                                        <v-list-tile v-show="hasEditRights && (isCreated(props.item)||isRejected(props.item))" @click="edit(props.item, props.index)" title="Click to edit this record">
                                            <v-list-tile-title>Edit</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile v-show="hasEditRights && isCreated(props.item)" @click="forReview(props.item, props.index)" title="Click to set this record to For Review">
                                            <v-list-tile-title>For Review</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile v-show="hasApproverRights && (isForReview(props.item)||isRejected(props.item))" @click="approve(props.item, props.index)" title="Click to Approve this record">
                                            <v-list-tile-title>Approve</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile v-show="hasApproverRights && (isForReview(props.item)||isApproved(props.item))" @click="reject(props.item, props.index)" title="Click to Reject this record">
                                            <v-list-tile-title>Reject</v-list-tile-title>
                                        </v-list-tile>
                                        <v-list-tile v-show="hasDeleteRights && (isCreated(props.item)||isRejected(props.item))" @click="showDeleteConfirmation(props.item, props.index)" title="Click to Delete this record">
                                            <v-list-tile-title>Delete</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </td>
                        </tr>
                    </template>
                    <template v-slot:expand="props">
                        <v-card flat>
                            <v-card-actions class="ml-15 mr-15">
                                <v-chip small>Created On:&nbsp;<b>{{ props.item.createdOn | moment('MMM DD, YYYY')}}</b></v-chip>
                                <v-spacer></v-spacer>
                                <span>
                                    Created By:
                                    <v-chip small>
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.createdByUser.userId)"></v-img>
                                        </v-avatar>
                                        <b>{{props.item.createdByUser.firstName}} {{props.item.createdByUser.lastName}}</b>
                                    </v-chip>
                                </span>
                                <span v-if="isApproved(props.item)">
                                    Approved By:
                                    <v-chip small>
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.approvedByUser.userId)"></v-img>
                                        </v-avatar>
                                        <b>{{props.item.approvedByUser.firstName}} {{props.item.approvedByUser.lastName}}</b>
                                    </v-chip>
                                </span>
                                <span v-if="isRejected(props.item)">
                                    Rejected By:
                                    <v-chip small>
                                        <v-avatar>
                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.updatedByUser.userId)"></v-img>
                                        </v-avatar>
                                        <b>{{props.item.updatedByUser.firstName}} {{props.item.updatedByUser.lastName}}</b>
                                    </v-chip>
                                </span>
                            </v-card-actions>
                        </v-card>
                    </template>
                </v-data-table>
            </v-card>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" ref="commentsRef" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogThresholdSummary" width="800">
            <threshold-summary :data="thresholdSummary" :dialogThresholdSummary.sync="dialogThresholdSummary"></threshold-summary>
        </v-dialog>
        <v-dialog v-model="dialogDelete" width="500">
            <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteRecord"></delete>
        </v-dialog>
        <v-dialog v-model="dialogAddEditDeminimis" persistent width="800">
            <add-edit-deminimis ref="addEditDeminimisRef" :dialogAddEditDeminimis.sync="dialogAddEditDeminimis" @send="getDeminimisHistory(false)"></add-edit-deminimis>
        </v-dialog>
        <v-dialog v-model="dialogAllEmployees" persistent width="700">
            <view-all-employees ref="refAllEmployees" :dialogAllEmployees.sync="dialogAllEmployees" @send="viewOtherEmployee"></view-all-employees>
        </v-dialog>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import benefitsApi from '@/api/benefits'
import commonfn from '@/common/functions'       //for refactor
import awsS3Helper from '@/helpers/aws-s3'
import numFormat from '@/common/num_format'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import payoutTypes from '@/constants/payout-types'
import { hasAddRights, hasEditRights, hasApproverRights, hasDeleteRights } from '@/helpers/access-permissions'

export default {     
    name: 'DeMinimisBenefitsDetails',
    metaInfo: {
        title: 'De Minimis Benefits Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'De Minimis Benefits Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'delete': () => import('@/components/BasicPopups/Delete'),
        'threshold-summary': () => import('@/components/Allocation/DeminimisThreshold'),
        'add-edit-deminimis': () => import('@/components/Allocation/AddEditDeminimis'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory'),
        'pay-on-month': () => import('@/components/Allocation/PayOnMonth'),
        'details-menu': () => import('@/components/Allocation/CompensationDetailsMenu'),
        'view-all-employees': () => import('@/components/Allocation/AllCompensationEmployees'),
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            numFormat,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            headers_deminimis: [
                {text: 'Year',align:'left',value:'fiscalYear',width: '2%', sortable:true},
                {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Payout On',align: 'left',value: '',width: '25%', sortable:false},
                {text: 'Payout Schedule',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Monthly Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Cutoff Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Annual Amount',align: 'right',value: '',width: '5%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '5%', sortable:false},
                {text: 'Action',align: 'left',value: '',width: '2%', sortable:false}
            ],
            dialogAllEmployees: false,
            dialogAddEditDeminimis: false,
            dialogThresholdSummary: false,
            dialogDelete: false,
            deleteData: null,
            deleteIndex: null,
            expand: false,
            error: false,
            errorMessage: '',
            loading: false,
            loading_action: [],
            userDetails: null,
            deminimisHistory: []
        }
    },
    methods: {
        viewOtherEmployee(userId){
            this.$router.push(`/compensation/allocation/${userId}/deminimis-benefits`)
        },
        showAllEmployees() {
            this.$refs.refAllEmployees.getEmployees()
            this.dialogAllEmployees = true
        },
        backToSummaryPage() {
            const selectedYear = userPrefs.getSelectedCompensationYear()
            const currentFiscalPeriodId = this.$store.state.fiscalPeriods.find(x => x.fiscalYear == selectedYear).fiscalPeriodId
            this.$router.push(`/compensation/allocation/${currentFiscalPeriodId}/${this.selectedUserId}`)
        },
        edit(data) {
            var data = {
                deminimis: data,
                userId: this.selectedUserId
            }
            this.$refs.addEditDeminimisRef.setUpdate(data)
            this.dialogAddEditDeminimis = true
        },
        add() {
            var data = {
                userId: this.selectedUserId
            }
            this.$refs.addEditDeminimisRef.setAdd(data)
            this.dialogAddEditDeminimis = true
        },
        showDeleteConfirmation(data, index) {
            this.deleteData = data
            this.deleteIndex = index
            this.$refs.refDeleteComponent.setMessage("Delete this De Minimis Benefit?")
            this.dialogDelete = true
        },
        async deleteRecord(){
             try {
                this.$set(this.loading_action, this.deleteIndex, true)

                await benefitsApi.deleteDeminimisAllocation(this.deleteData.deminimisAllocationId)
                await this.getDeminimisHistory(false)
                this.dialogDelete = false

                this.$set(this.loading_action, this.deleteIndex, false)
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async reject(data, index){
            try {
                this.$set(this.loading_action, index, true)

                await benefitsApi.rejectDeminimis(data.deminimisAllocationId) 
                await this.getDeminimisHistory(false)

                this.$set(this.loading_action, index, false)
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async approve(data, index){
            try { 
                this.$set(this.loading_action, index, true)

                await benefitsApi.approveDeminimis(data.deminimisAllocationId) 
                await this.getDeminimisHistory(false)

                this.$set(this.loading_action, index, false)
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        async forReview(data, index){
            try { 
                this.$set(this.loading_action, index, true)

                await benefitsApi.forReviewDeminimis(data.deminimisAllocationId)
                await this.getDeminimisHistory(false)

                this.$set(this.loading_action, index, false)
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        getPayoutType(payoutMode) {
            return payoutTypes.filter(item => {
                return item.payoutMode == payoutMode
            })[0].description
        },
        isCreated(data){
            return data.status == commonfn.getStatusCode('Created')
        },
        isForReview(data){
            return data.status == commonfn.getStatusCode('For Review')
        },
        isRejected(data){
            return data.status == commonfn.getStatusCode('Rejected')
        },
        isApproved(data){
            return data.status == commonfn.getStatusCode('Approved')
        },
        computeDeminimisThreshold() {
            const map = {}

            this.deminimisHistory.forEach(r => {
                // group by Year + Benefit Type
                const key = `${r.fiscalYear}_${r.benefitTypeId}`

                if (!map[key]) {
                    map[key] = {
                    fiscalYear: r.fiscalYear,
                    deminimisName: r.deminimisName,
                    benefitTypeId: r.benefitTypeId,
                    annualAmount: 0,
                    annualThreshold: r.annualThreshold || 0
                    }
                }

                // sum annual payment
                map[key].annualAmount += Number(r.annualPayment || 0)
            })

                // finalize result
            return Object.values(map).map(item => ({
                fiscalYear: item.fiscalYear,
                deminimisName: item.deminimisName,
                annualAmount: item.annualAmount,
                annualThreshold: item.annualThreshold,
                annualExcess: Math.max(
                    item.annualAmount - item.annualThreshold,
                    0
                )
            }))
        },
        async getDeminimisHistory(displayLoading) {
            try {
                this.loading = displayLoading
                const response = await benefitsApi.getDeminimisHistory(this.selectedUserId)
                if (response && response.status == 200) {
                    this.userDetails = response.data.user
                    this.deminimisHistory = response.data.items
                }
                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getDeminimisHistory(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        }
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: 'De Minimis Benefits Details',
        })

        await this.getDeminimisHistory(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        selectedUserId: {
            immediate: true, // runs on first load
            async handler(newUserId, oldUserId) {
                if (!newUserId) return

                // optional guard
                if (newUserId === oldUserId) return

                await this.getDeminimisHistory(false)
            }
        }
    },
    computed: {
        hasAddRights() {
            return hasAddRights(this.$router.currentRoute.path)
        },
        hasEditRights() {
            return hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return hasApproverRights(this.$router.currentRoute.path)
        },
        hasDeleteRights() {
            return hasDeleteRights(this.$router.currentRoute.path)
        },
        selectedUserId() {
            return this.$route.params.userId
        },
        isMobile() {
            return window.innerWidth < 600
        },
        pageQueryId() {
            return `deminimis-benefits-${this.selectedUserId}`
        },
        commentsData() {
            if (!this.loading) {
                //for refactoring, separate params of comments notif 
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null, 
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.allocation,
                    notificationTypeId: notificationTypes.allocation
                }
            }
        },
        isResignedOrTerminated() {
            return this.userDetails.employmentStatus == commonfn.getStatusCode('Resigned') ||
                    this.userDetails.employmentStatus == commonfn.getStatusCode('Terminated')
        },
        isDeactivted() {
            return this.userDetails.employmentStatus == commonfn.getStatusCode('Deactivated')
        },
        thresholdSummary() {
            return this.computeDeminimisThreshold()
        }
    }
}
</script>
<style scoped>
.form-data {
    padding:0px 20px 0px 50px;
}
.form-data-mobile {
    padding:0px 0px 0px 10px;
}
.progress-bar-top {
    margin:1px -3px 0px -3px;
}
.section-layout {
    padding:5px 23px 5px 23px;
}
</style>